import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import WealthSecurityForFloridaFamilies from "./sections/WealthSecurityForFloridaFamilies";
import ThePillarsOfPreservation from "./sections/ThePillarsOfPreservation";
import WhyLegacyWealthLegal from "./sections/WhyLegacyWealthLegal";
import TheLegacyAuditProcess from "./sections/TheLegacyAuditProcess";
import VoicesOfSecurity from "./sections/VoicesOfSecurity";
import SecureYourFutureToday from "./sections/SecureYourFutureToday";
import Visualsitemap from "./sections/Visualsitemap";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <WealthSecurityForFloridaFamilies />
      <ThePillarsOfPreservation />
      <WhyLegacyWealthLegal />
      <TheLegacyAuditProcess />
      <VoicesOfSecurity />
      <SecureYourFutureToday />
      <Visualsitemap />
      <Footer />
    </div>;
}